var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370.97 370.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d656b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.89,138.22h-10.81c-18.29,0-33.17,14.88-33.17,33.16v112.61c0,18.29,14.88,33.17,33.17,33.17h10.81c18.29,0,33.17-14.88,33.17-33.17v-112.61c0-18.28-14.88-33.16-33.17-33.16ZM190.89,302.08h-10.81c-9.97,0-18.1-8.12-18.1-18.1v-112.61c0-9.97,8.12-18.09,18.1-18.09h10.81c9.97,0,18.1,8.11,18.1,18.09v112.61c0,9.97-8.12,18.1-18.1,18.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.48,53.81c-21.26,0-38.57,17.31-38.57,38.57s17.31,38.57,38.57,38.57,38.58-17.3,38.58-38.57-17.31-38.57-38.58-38.57ZM185.48,115.88c-12.95,0-23.5-10.53-23.5-23.5s10.54-23.5,23.5-23.5,23.51,10.54,23.51,23.5-10.54,23.5-23.51,23.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.49,0C83.05,0,0,83.05,0,185.49s83.05,185.48,185.49,185.48,185.48-83.05,185.48-185.48S287.92,0,185.49,0ZM185.48,355.31c-93.63,0-169.82-76.18-169.82-169.83S91.84,15.66,185.48,15.66s169.83,76.18,169.83,169.82-76.18,169.83-169.83,169.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.b12554608ee9fac460e3f7a7315dbb99.svg";
export { ForwardRef as ReactComponent };